<template>
  <div class="currency-input clearfix">
    <div v-if="!hide" class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'">
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="input-group">
          <input class="form-control" type="text"
            :id="options.name"
            :value="value"
            :name="options.name"
            @input="validate($event.target.value)"/>
          <div class="input-group-addon">
            <span class="input-group-text">
              <template v-if="isRegex">
                {{ value | toDollarAmount }}
              </template>
              <template v-else>
                Invalid Dollar Amount
              </template>
            </span>
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/vuex/api'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'CurrencyInput',
  props: {
    value: {
      type: [String, Number]
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: '',
          required: false
        }
      }
    }
  },
  data () {
    return {
      isValid: false,
      isDirty: false,
      isLength: false,
      isRegex: false,
      regex: /^[0-9]*(\.[0-9]{1,2}){0,1}$/,
      maxValue: false,
      minValue: false,
      hide: false,
      lots: false,
      levels: false,
      propertyType: false
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage,
    invalidMessage () {
      if (this.maxValue && this.value > this.maxValue && this.isRegex) {
        return 'Amount cannot be more than $' + this.maxValue
      } else if (this.minValue || this.options.minValue === 0 && this.value <= this.minValue && this.isRegex) {
        return 'Amount must be more than $' + this.minValue
      } else {
        return 'The amount entered is not a valid dollar amount'
      }
    }
  },
  mounted () {
    if (this.options.hidden) this.hide = true
    if (this.options.maxValue) {
      this.maxValue = parseFloat(this.options.maxValue)
    }
    if (this.options.minValue || this.options.minValue === 0) {
      this.minValue = parseFloat(this.options.minValue)
    }
    this.validate()
  },
  methods: {
    validate (val = this.value) {
      if (val === null) {
        val = '0'
      }
      this.$emit('input', val)
      if (val) {
        this.isDirty = true
        this.isLength = this.isValid = val.length !== 0
        if (this.isValid) {
          this.isRegex = this.isValid = new RegExp(this.regex, 'gi').test(val)
        }
        if (this.maxValue && this.isValid) {
          this.isValid = parseFloat(val) <= this.maxValue
        }
        if (this.minValue || this.options.minValue === 0 && this.isValid) {
          this.isValid = this.isValid && parseFloat(val) > this.minValue
        }
      } else if (this.options.required) {
        this.isDirty = true
        this.isValid = false
      } else {
        this.isValid = true
      }
    },
    async updateQuoteCost () {
      if (this.lots && this.levels && this.propertyType) {
        let quoteTypeUuid = this.$parent.$refs.fields.find(el => el.options.name === 'QuoteTypeUuid')
        let options = {
          lots: this.lots,
          levels: this.levels,
          propertyType: this.propertyType,
          quoteTypeUuid: quoteTypeUuid.value
        }
        let instance = new Api()
        let quoteCost = await instance.getQuoteCost(options)
        this.validate(quoteCost)
      }
    },
    async runWatcher (val, name) {
      if (this.options.watchers.includes(name)) {
        if (val || val === false) {
          switch (name) {
            case 'lots':
              this.lots = val
              let levelsField = this.$parent.$refs.fields.find(el => el.options.name === 'levels')
              if (levelsField.value) {
                this.levels = levelsField.value
              }
              let propertyTypeField = this.$parent.$refs.fields.find(el => el.options.name === 'propertyType')
              if (propertyTypeField.value) {
                this.propertyType = propertyTypeField.value
              }
              await this.updateQuoteCost()
              break
            case 'propertyType':
              this.propertyType = val
              let levelsField2 = this.$parent.$refs.fields.find(el => el.options.name === 'levels')
              if (levelsField2.value) {
                this.levels = levelsField2.value
              }
              let lotsField2 = this.$parent.$refs.fields.find(el => el.options.name === 'lots')
              if (lotsField2.value) {
                this.lots = lotsField2.value
              }
              await this.updateQuoteCost()
              break
            case 'levels':
              this.levels = val
              let lotsField = this.$parent.$refs.fields.find(el => el.options.name === 'lots')
              if (lotsField.value) {
                this.lots = lotsField.value
              }
              let propertyType = this.$parent.$refs.fields.find(el => el.options.name === 'propertyType')
              if (propertyType.value) {
                this.propertyType = propertyType.value
              }
              await this.updateQuoteCost()
              break
            // case 'pBGrCheaperQuoteCost':
            //   this.validate(val - val / 10)
            //   break
          }
        } else {
          this.validate('')
          this.isDirty = false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/CurrencyInput.vue